import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=ae941b6a&scoped=true"
import script from "./privilege.vue?vue&type=script&lang=js"
export * from "./privilege.vue?vue&type=script&lang=js"
import style0 from "./privilege.vue?vue&type=style&index=0&id=ae941b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae941b6a",
  null
  
)

export default component.exports